import gql from 'graphql-tag';

function assembleQuery(queryFn, fragments) {
  const fragmentArray = Array.isArray(fragments) ? fragments : [fragments];
  const fragmentNames = fragmentArray.map(
    f => `...${f.definitions[0].name.value}\n`
  );
  const q = queryFn(fragmentNames);
  return gql([q, ''], ...fragmentArray);
}

function assembleMultiQuery(queryFn, fragmentMap) {
  const fragmentArray = Object.values(fragmentMap).flatMap(v => v);
  const fragmentNames = Object.fromEntries(
    Object.entries(fragmentMap).map(([k, v]) => ([k, v.map(f => `...${f.definitions[0].name.value}\n`)]))
  );
  const q = queryFn(fragmentNames);
  return gql(q, ...fragmentArray);
}

export { assembleQuery, assembleMultiQuery };
